module.exports = __webpack_public_path__ + "static/media/me.424353db.jpeg";